'use client'

import { useUserContext } from "@/Context/UserContext";
import { ChevronIcon } from "@/app/home/Icons";
import { sendGTMEvent } from "@next/third-parties/google";
import Link from "next/link";

export const BookButton = () => {
  const { user } = useUserContext();

  const handleClickLink = () => {
    sendGTMEvent({ event: "Bookـnowـclicked" });
    if ((window as any).webengage && user) {
      (window as any).webengage.track("Services Chosen - Home screen", {
        type: "Instant",
        flow: user.instantFlow,
        fromWeb: true,
      });
    }
  };
  return (
    <Link
      onClick={handleClickLink}
      href={"/book-instant"}
      className="w-36 h-10 pr-4 focus:ring-4 py-2.5 bg-blue-base hover:bg-blue-700 rounded-full text-center text-white-base flex items-center justify-center"
    >
      {"احجز الآن"}
      <ChevronIcon />
    </Link>
  );
};
